import axios from 'axios';
import config from './config';

const DEBUG = process.env.NODE_ENV === 'development';
const accessTokenField = config.access_token_field_name || 'access_token';

export const taApiClient = axios.create({
	baseURL: config.api_url
	// timeout: 10000
});

taApiClient.interceptors.request.use(request => {
	if (request.headers) {
		if (localStorage.getItem(accessTokenField))
			request.headers.authorization = `Bearer ${localStorage.getItem(accessTokenField)}`;
		request.headers.accepts = 'application/json';
	}
	return request;
});

taApiClient.interceptors.response.use(
	response => response,
	error => {
		if (DEBUG) console.error(error);
		if (error.response && error.response.status === 401) {
			return Promise.reject(
				new Error(error.response.data.message || 'You are unauthorized, please try to sign in again.')
			);
		}
		return Promise.reject(error.response ? error.response.data : error);
	}
);

export default axios;
